var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBookingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#004A2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.375 10.75C10.5739 10.75 10.7647 10.829 10.9053 10.9697C11.046 11.1103 11.125 11.3011 11.125 11.5C11.125 11.6989 11.046 11.8897 10.9053 12.0303C10.7647 12.171 10.5739 12.25 10.375 12.25C10.1761 12.25 9.98532 12.171 9.84467 12.0303C9.70402 11.8897 9.625 11.6989 9.625 11.5C9.625 11.0837 9.95875 10.75 10.375 10.75ZM4.375 4.75H5.60125L5.95375 5.5H11.5C11.5995 5.5 11.6948 5.53951 11.7652 5.60983C11.8355 5.68016 11.875 5.77554 11.875 5.875C11.875 5.93875 11.8562 6.0025 11.83 6.0625L10.4875 8.48875C10.36 8.7175 10.1125 8.875 9.83125 8.875H7.0375L6.7 9.48625L6.68875 9.53125C6.68875 9.55611 6.69863 9.57996 6.71621 9.59754C6.73379 9.61512 6.75764 9.625 6.7825 9.625H11.125V10.375H6.625C6.42609 10.375 6.23532 10.296 6.09467 10.1553C5.95402 10.0147 5.875 9.82391 5.875 9.625C5.875 9.49375 5.90875 9.37 5.965 9.265L6.475 8.34625L5.125 5.5H4.375V4.75ZM6.625 10.75C6.82391 10.75 7.01468 10.829 7.15533 10.9697C7.29598 11.1103 7.375 11.3011 7.375 11.5C7.375 11.6989 7.29598 11.8897 7.15533 12.0303C7.01468 12.171 6.82391 12.25 6.625 12.25C6.42609 12.25 6.23532 12.171 6.09467 12.0303C5.95402 11.8897 5.875 11.6989 5.875 11.5C5.875 11.0837 6.20875 10.75 6.625 10.75ZM10 8.125L11.0425 6.25H6.3025L7.1875 8.125H10Z",
    fill: "#CCEADE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookingCart);
export default __webpack_public_path__ + "static/media/IconBookingCart.09720640d4cfc0734c78c50b0dde8416.svg";
export { ForwardRef as ReactComponent };